<template>

</template>

<script>
  import env from "@/utils/env";
  import axios from "axios";
  import authenticationInterceptor from "@/components/core/authentication/AuthenticationInterceptor"
  import EzUtils from "@/utils/EzUtils";
  import { Constants } from "@/components/Constants"

  export default {
    name: "FileDownload",
    data: () => ({
      downloader: null
    }),
    props: {
      link: {
        type: String,
        required: true
      },

      download: {
        type: Boolean,
        required: true,
        default: false
      },

      saveFile: {
        type: Boolean,
        default: true
      },

      documentName: {
        type: String,
      },

      fileExtension: {
        type: String,
        default: ''
      }
    },

    methods: {},

    watch: {
      download() {
        let responseType = 'arraybuffer';
        if (this.saveFile) {
          responseType = 'blob';
        }
        if (this.download && this.downloader && this.link) {
          if (env.isWebPlatform()) {
            this.downloader.get(this.link, { responseType: responseType })
              .then(res => {
                const url = window.URL || window.webkitURL

                let applicationType = null;
                if (!this.saveFile) {
                  if (this.fileExtension === 'pdf') {
                    applicationType = "Application/pdf"
                  } else if (Constants.IMAGE_EXTENSIONS.includes(this.fileExtension)) {
                    applicationType = "Application/octet-stream"
                  }
                }

                let objectUrl = null
                if (applicationType == null) {
                  objectUrl = url.createObjectURL(new Blob([res.data]))
                } else {
                  objectUrl = new Blob([res.data], { type: applicationType })
                }

                if (this.saveFile) {
                  const link = document.createElement('a');
                  link.href = objectUrl;
                  if (EzUtils.isNotEmpty(this.fileExtension)) {
                    link.setAttribute('download', `${this.documentName}.${this.fileExtension}`);
                  } else {
                    link.setAttribute('download', this.documentName);
                  }
                  document.body.appendChild(link);
                  link.click();
                  this.$emit('fileDownloaded', {})
                } else {
                  this.$emit('fileDownloaded', { 'bufferUrl': objectUrl })
                }
              })
              .catch(error => {
                this.$emit('fileNotDownloaded', {})
              })
          } else {
            //Use natjs to download file
            // TODO need to implement for ios and android
          }
        }
      }
    },

    created() {
      this.downloader = axios.create({
        headers: {
          "Content-Type": "application/octet-stream",
          "Authorization": authenticationInterceptor.getAuthorizationHeader(),
          // "Content-Disposition": 'attachment'
        }
      });
    }
  }

</script>

<style scoped></style>
